// Home page actions
export const GET_HOMEPAGE_SUCCESS = "GET_HOMEPAGE_SUCCESS";
export const GET_HOMEPAGE_FAILURE = "GET_HOMEPAGE_FAILURE";

export const GET_MEALDEAL_SUCCESS = "GET_MEALDEAL_SUCCESS";
export const GET_MEALDEAL_FAILURE = "GET_MEALDEAL_FAILURE";

export const GET_ABOUT_SUCCESS = "GET_ABOUT_SUCCESS";
export const GET_ABOUT_FAILURE = "GET_ABOUT_FAILURE";

export const GET_GALLERY_SUCCESS = "GET_GALLERY_SUCCESS";
export const GET_GALLERY_FAILURE = "GET_GALLERY_FAILURE";

export const GET_REVIEW_SUCCESS = "GET_REVIEW_SUCCESS";
export const GET_REVIEW_FAILURE = "GET_REVIEW_FAILURE";

export const GET_SIGNUP_SUCCESS = "GET_SIGNUP_SUCCESS";
export const GET_SIGNUP_FAILURE = "GET_SIGNUP_FAILURE";

export const GET_FOOTER_SUCCESS = "GET_FOOTER_SUCCESS";
export const GET_FOOTER_FAILURE = "GET_FOOTER_FAILURE";

export const GET_TABLEBOOKING_SUCCESS = "GET_TABLEBOOKING_SUCCESS";
export const GET_TABLEBOOKING_FAILURE = "GET_TABLEBOOKING_FAILURE";

export const GET_MAIN_TABLEBOOKING_SUCCESS = "GET_MAIN_TABLEBOOKING_SUCCESS";
export const GET_MAIN_TABLEBOOKING_FAILURE = "GET_MAIN_TABLEBOOKING_FAILURE";

export const GET_FEEDBACK_SUCCESS = "GET_FEEDBACK_SUCCESS";
export const GET_FEEDBACK_FAILURE = "GET_FEEDBACK_FAILURE";

// User actions
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_FAILURE = "GET_USER_FAILURE";

// User stripe
export const SET_STRIPE = "SET_STRIPE";

// Send app link actions
export const SEND_APP_LINK_REQUEST = "SEND_APP_LINK_REQUEST";
export const SEND_APP_LINK_SUCCESS = "SEND_APP_LINK_SUCCESS";
export const SEND_APP_LINK_FAILURE = "SEND_APP_LINK_FAILURE";

// My Account - wallet history page actions
export const GET_WALLETHISTORY_SUCCESS = "GET_WALLETHISTORY_SUCCESS";
export const GET_WALLETHISTORY_FAILURE = "GET_WALLETHISTORY_FAILURE";

// My Account - wallet dashboard page actions
export const GET_WALLETDASHBOARD_SUCCESS = "GET_WALLETDASHBOARD_SUCCESS";
export const GET_WALLETDASHBOARD_FAILURE = "GET_WALLETDASHBOARD_FAILURE";

// My Account - wallet Save Card page actions
export const GET_SAVECARD_SUCCESS = "GET_SAVECARD_SUCCESS";
export const GET_SAVECARD_FAILURE = "GET_SAVECARD_FAILURE";

// My Account - Add Save Card page actions
export const ADD_SAVECARD_SUCCESS = "ADD_SAVECARD_SUCCESS";
export const ADD_SAVECARD_FAILURE = "ADD_SAVECARD_FAILURE";

// My Account - wallet Save Card page actions
export const DELETE_SAVECARD_SUCCESS = "DELETE_SAVECARD_SUCCESS";
export const DELETE_SAVECARD_FAILURE = "DELETE_SAVECARD_FAILURE";

// My Account - wallet Save Card page actions
export const UPDATE_PRIMARYSAVECARD_SUCCESS = "UPDATE_PRIMARYSAVECARD_SUCCESS";
export const UPDATE_PRIMARYSAVECARD_FAILURE = "UPDATE_PRIMARYSAVECARD_FAILURE";

// My Account - Order history page actions
export const GET_ORDERHISTORY_SUCCESS = "GET_ORDERHISTORY_SUCCESS";
export const GET_ORDERHISTORY_FAILURE = "GET_ORDERHISTORY_FAILURE";

// My Account - Order detail page actions
export const GET_ORDERDETAIL_SUCCESS = "GET_ORDERDETAIL_SUCCESS";
export const GET_ORDERDETAIL_FAILURE = "GET_ORDERDETAIL_FAILURE";

// My Account - Address page actions
export const GET_ADDRESS_SUCCESS = "GET_ADDRESS_SUCCESS";
export const GET_ADDRESS_FAILURE = "GET_ADDRESS_FAILURE";

// My Account - Update Address page actions
export const UPDATE_ADDRESS_SUCCESS = "UPDATE_ADDRESS_SUCCESS";
export const UPDATE_ADDRESS_FAILURE = "UPDATE_ADDRESS_FAILURE";

// My Account - Delete Address page actions
export const DELETE_ADDRESS_SUCCESS = "DELETE_ADDRESS_SUCCESS";
export const DELETE_ADDRESS_FAILURE = "DELETE_ADDRESS_FAILURE";

// My Account - Update Primary Address page actions
export const UPDATEPRIMARY_ADDRESS_SUCCESS = "UPDATEPRIMARY_ADDRESS_SUCCESS";
export const UPDATEPRIMARY_ADDRESS_FAILURE = "UPDATEPRIMARY_ADDRESS_FAILURE";

// My Account - Add Address page actions
export const ADD_ADDRESS_SUCCESS = "ADD_ADDRESS_SUCCESS";
export const ADD_ADDRESS_FAILURE = "ADD_ADDRESS_FAILURE";

// My Account - get Profile  page actions
export const GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS";
export const GET_PROFILE_FAILURE = "GET_PROFILE_FAILURE";

// login actions
export const GET_LOGIN_SUCCESS = "GET_LOGIN_SUCCESS";
export const GET_LOGIN_FAILURE = "GET_LOGIN_FAILURE";
export const LOGOUT = "LOGOUT";
export const SET_LOGGED_IN = "SET_LOGGED_IN";

// list page data
export const RESTAURANT_PAGE_REQUEST = "RESTAURANT_PAGE_REQUEST";
export const RESTAURANT_PAGE_SUCCESS = "RESTAURANT_PAGE_SUCCESS";
export const RESTAURANT_PAGE_FAILURE = "RESTAURANT_PAGE_FAILURE";
export const CLEAR_PAGE_DATA = "CLEAR_PAGE_DATA";
//list cuisines
export const RESTAURANT_CUISINES_REQUEST = "RESTAURANT_CUISINES_REQUEST";
export const RESTAURANT_CUISINES_SUCCESS = "RESTAURANT_CUISINES_SUCCESS";
export const RESTAURANT_CUISINES_FAILURE = "RESTAURANT_CUISINES_FAILURE";
export const CLEAR_CUISINES_DATA = "CLEAR_CUISINES_DATA";
//
//list FILTER
export const RESTAURANT_FILTER_REQUEST = "RESTAURANT_FILTER_REQUEST";
export const RESTAURANT_FILTER_SUCCESS = "RESTAURANT_FILTER_SUCCESS";
export const RESTAURANT_FILTER_FAILURE = "RESTAURANT_FILTER_FAILURE";
export const CLEAR_FILTER_DATA = "CLEAR_FILTER_DATA";
//
// no takeaway page data
export const SUGGEST_RESTAURANT_REQUEST = "SUGGEST_RESTAURANT_REQUEST";
export const SUGGEST_RESTAURANT_SUCCESS = "SUGGEST_RESTAURANT_SUCCESS";
export const SUGGEST_RESTAURANT_FAILURE = "SUGGEST_RESTAURANT_FAILURE";

// restaurant detail data
export const RESTAURANT_DETAIL_REQUEST = "RESTAURANT_DETAIL_REQUEST";
export const RESTAURANT_DETAIL_SUCCESS = "RESTAURANT_DETAIL_SUCCESS";
export const RESTAURANT_DETAIL_FAILURE = "RESTAURANT_DETAIL_FAILURE";

// menu detail data
export const MENU_DETAIL_REQUEST = "MENU_DETAIL_REQUEST";
export const MENU_DETAIL_SUCCESS = "MENU_DETAIL_SUCCESS";
export const MENU_DETAIL_FAILURE = "MENU_DETAIL_FAILURE";

// Menu page tablebooking gallery 
export const TABLE_BOOK_GALLERY_REQUEST = "TABLE_BOOK_GALLERY_REQUEST";
export const TABLE_BOOK_GALLERY_SUCCESS = "TABLE_BOOK_GALLERY_SUCCESS";
export const TABLE_BOOK_GALLERY_FAILURE = "TABLE_BOOK_GALLERY_FAILURE";

// about detail data
export const ABOUT_DETAIL_REQUEST = "ABOUT_DETAIL_REQUEST";
export const ABOUT_DETAIL_SUCCESS = "ABOUT_DETAIL_SUCCESS";
export const ABOUT_DETAIL_FAILURE = "ABOUT_DETAIL_FAILURE";

// about detail data
export const REVIEW_DETAIL_REQUEST = "REVIEW_DETAIL_REQUEST";
export const REVIEW_DETAIL_SUCCESS = "REVIEW_DETAIL_SUCCESS";
export const REVIEW_DETAIL_FAILURE = "REVIEW_DETAIL_FAILURE";

//Addon detail data
export const ADDON_DETAIL_REQUEST = "ADDON_DETAIL_REQUEST";
export const ADDON_DETAIL_SUCCESS = "ADDON_DETAIL_SUCCESS";
export const ADDON_DETAIL_FAILURE = "ADDON_DETAIL_FAILURE";
export const ADDON_DETAIL_LOAD = "ADDON_DETAIL_LOAD";

// Order Again
export const GET_ORDERAGAIN_SUCCESS = "GET_ORDERAGAIN_SUCCESS";
export const GET_ORDERAGAIN_FAILURE = "GET_ORDERAGAIN_FAILURE";

// Order My account Feedback
export const GET_MYACCOUNTFEEDBACK_SUCCESS = "GET_MYACCOUNTFEEDBACK_SUCCESS";
export const GET_MYACCOUNTFEEDBACK_FAILURE = "GET_MYACCOUNTFEEDBACK_FAILURE";

// Order Tracking
export const GET_ORDERTRACKING_SUCCESS = "GET_ORDERTRACKING_SUCCESS";
export const GET_ORDERTRACKING_FAILURE = "GET_ORDERTRACKING_FAILURE";

// Send OTP profile
export const SENDOTP_PROFILE_SUCCESS = "SENDOTP_PROFILE_SUCCESS";
export const SENDOTP_PROFILE_FAILURE = "SENDOTP_PROFILE_FAILURE";

// Save Profile
export const SAVE_PROFILE_SUCCESS = "SAVE_PROFILE_SUCCESS";
export const SAVE_PROFILE_FAILURE = "SAVE_PROFILE_FAILURE";

// Lead signup actions
export const LEAD_SIGN_UP_REQUEST = "LEAD_SIGN_UP_REQUEST";
export const LEAD_SIGN_UP_SUCCESS = "LEAD_SIGN_UP_SUCCESS";
export const LEAD_SIGN_UP_FAILURE = "LEAD_SIGN_UP_FAILURE";

// Contactless dinning actions
export const CONTACT_LESS_DINNING_REQUEST = "CONTACT_LESS_DINNING_REQUEST";
export const CONTACT_LESS_DINNING_SUCCESS = "CONTACT_LESS_DINNING_SUCCESS";
export const CONTACT_LESS_DINNING_FAILURE = "CONTACT_LESS_DINNING_FAILURE";

// Career actions
export const CAREER_REQUEST = "CAREER_REQUEST";
export const CAREER_SUCCESS = "CAREER_SUCCESS";
export const CAREER_FAILURE = "CAREER_FAILURE";

// no partner page data
export const BECOMEPARTNER_REQUEST = "BECOMEPARTNER_REQUEST";
export const BECOMEPARTNER_SUCCESS = "BECOMEPARTNER_SUCCESS";
export const BECOMEPARTNER_FAILURE = "BECOMEPARTNER_FAILURE";

// reseller signup data
export const RESELLER_REQUEST = "RESELLER_REQUEST";
export const RESELLER_SUCCESS = "RESELLER_SUCCESS";
export const RESELLER_FAILURE = "RESELLER_FAILURE";

//cart data
export const CART_DETAIL_SUCCESS = "CART_DETAIL_SUCCESS";
export const CART_DETAIL_FAILURE = "CART_DETAIL_FAILURE";

// feedback status data
export const FEEDBACK_STATUS_REQUEST = "FEEDBACK_STATUS_REQUEST";
export const FEEDBACK_STATUS_SUCCESS = "FEEDBACK_STATUS_SUCCESS";
export const FEEDBACK_STATUS_FAILURE = "FEEDBACK_STATUS_FAILURE";

// create feedback data
export const CREATE_FEEDBACK_REQUEST = "CREATE_FEEDBACK_REQUEST";
export const CREATE_FEEDBACK_SUCCESS = "CREATE_FEEDBACK_SUCCESS";
export const CREATE_FEEDBACK_FAILURE = "CREATE_FEEDBACK_FAILURE";

// Checkout page - placeorder data
export const PLACEORDER_SUCCESS = "PLACEORDER_SUCCESS";
export const PLACEORDER_FAILURE = "PLACEORDER_FAILURE";
export const CLEAR_PLACEORDER = "CLEAR_PLACEORDER";
export const PLACEORDER_STATUS = "PLACEORDER_STATUS";
export const PLACECARD_STATUS = "PLACECARD_STATUS";

// Checkout page - placeorder data
export const CHARGESDETAIL_SUCCESS = "CHARGESDETAIL_SUCCESS";
export const CHARGESDETAIL_FAILURE = "CHARGESDETAIL_FAILURE";

// stripe payment details - placeorder data
export const SPD_SUCCESS = "SPD_SUCCESS";
export const SPD_FAILURE = "SPD_FAILURE";

// get loyalty points based on ordered amount
export const GET_LOYALTY_SUCCESS = "GET_LOYALTY_SUCCESS";
export const GET_LOYALTY_FAILURE = "GET_LOYALTY_FAILURE";
//autocomplete
export const AUTOCOMPLETE_SUCCESS = "AUTOCOMPLETE_SUCCESS";
export const AUTOCOMPLETE_FAILURE = "AUTOCOMPLETE_FAILURE";
export const MERGE_VALUES = "MERGE_VALUES";
export const CLEAR_DATA = "CLEAR_DATA";

// social url details - placeorder data
export const GET_SOCIAL_SUCCESS = "GET_SOCIAL_SUCCESS";
export const GET_SOCIAL_FAILURE = "GET_SOCIAL_FAILURE";

// menu image url details - placeorder data
export const GET_MENU_IMAGE_SUCCESS = "GET_MENU_IMAGE_SUCCESS";
export const GET_MENU_IMAGE_FAILURE = "GET_MENU_IMAGE_FAILURE";

//
export const CLIENT_FEEDBACK_REQUEST = "CLIENT_FEEDBACK_REQUEST";
export const CLIENT_FEEDBACK_SUCCESS = "CLIENT_FEEDBACK_SUCCESS";
export const CLIENT_FEEDBACK_FAILURE = "CLIENT_FEEDBACK_FAILURE";
export const CLIENT_FEEDBACK_RESET = "CLIENT_FEEDBACK_RESET";

//subscribePlan-R
export const SUBSCRIBE_SUCCESS = "SUBSCRIBE_SUCCESS";
export const SUBSCRIBE_FAILURE = "SUBSCRIBE_FAILURE";
export const CLEAR_SUBSCRIBE = "CLEAR_SUBSCRIBE";
export const SUBSCRIBE_STATUS = "SUBSCRIBE_STATUS";

//subscribeCoupon-R
export const SUBSCRIBE_COUPON_SUCCESS = "SUBSCRIBE_SUCCESS";
export const SUBSCRIBE_COUPON_FAILURE = "SUBSCRIBE_FAILURE";
export const CLEAR_COUPON_SUBSCRIBE = "CLEAR_SUBSCRIBE";
export const SUBSCRIBE_COUPON_STATUS = "SUBSCRIBE_STATUS";

//promotion status-R
export const PROMOTION_STATUS_REQUEST = "PROMOTION_STATUS_REQUEST";
export const PROMOTION_STATUS_SUCCESS = "PROMOTION_STATUS_SUCCESS";
export const PROMOTION_STATUS_FAILURE = "PROMOTION_STATUS_FAILURE";

//our Branch status-R
export const BRANCH_STATUS_REQUEST = "BRANCH_STATUS_REQUEST";
export const BRANCH_STATUS_SUCCESS = "BRANCH_STATUS_SUCCESS";
export const BRANCH_STATUS_FAILURE = "BRANCH_STATUS_FAILURE";

//our Gallery status-R
export const GALLERY_STATUS_REQUEST = "GALLERY_STATUS_REQUEST";
export const GALLERY_STATUS_SUCCESS = "GALLERY_STATUS_SUCCESS";
export const GALLERY_STATUS_FAILURE = "GALLERY_STATUS_FAILURE";

// client Branch List
export const CLIENT_BRANCH_LIST_REQUEST = "CLIENT_BRANCH_LIST_REQUEST";
export const CLIENT_BRANCH_LIST_SUCCESS = "CLIENT_BRANCH_LIST_SUCCESS";
export const CLIENT_BRANCH_LIST_FAILURE = "CLIENT_BRANCH_LIST_FAILURE";

// client Branch List
export const AFTER_PLACEORDER_SUCCESS = "AFTER_PLACEORDER_SUCCESS";
export const AFTER_PLACEORDER_FAILURE = "AFTER_PLACEORDER_FAILURE";
export const AFTER_CLEAR_PLACEORDER = "AFTER_CLEAR_PLACEORDER";

// Franchise Lead Form
export const FRANCHISELEADFORM_SUCCESS = "FRANCHISELEADFORM_SUCCESS";
export const FRANCHISELEADFORM_FAILURE = "FRANCHISELEADFORM_FAILURE";
export const FRANCHISELEADFORM_REQUEST = "FRANCHISELEADFORM_REQUEST";
